'use strict';
import { cn_object_instance } from '../model/cn_object_instance';
import { cn_roof } from '../model/cn_roof';
import { cn_space } from '../model/cn_space';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_edit_box } from './cn_edit_box';
import {
    cn_description_input,
    cn_input_generic_field_boolean,
    cn_input_generic_field_number,
    cn_input_generic_field_string,
    cn_number_input,
    cn_number_list_input,
    cn_space_equipments_input,
    cn_space_input,
} from './cn_inputs';
import { cn_pastille } from './cn_pastille';
import {cn_svg_map} from './cn_svg_map';
import { extension_instance } from '../extension/cn_extension';
import { logger } from '../utils/cn_logger';
import { cn_space_dummy } from '../model/cn_space_dummy';

export class cn_space_dummy_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_space_dummy>} spaces
     * @param {cn_svg_map} map
     */
    constructor(spaces, map) {
        super(spaces, map);

        this._map = map;
        this._scene = spaces[0].parent;
        this._transaction_manager =
            spaces[0].parent.storey.building.transaction_manager;
        this._roof = this._scene.constructor == cn_roof;
        this._storey = spaces[0].parent.storey;
        //*** marker
        this._spaces = spaces;

        //*** Edit box for mass selection */
        const edit_box = new cn_edit_box(this, spaces, this._readOnly);
        this._handlers.push(edit_box);

        const obj = this;

        //*** details */
        const same_space_type = spaces.every((sp) => sp.space_type.ID === spaces[0].space_type.ID);
        if (spaces.length && same_space_type) {
            this._details_pastille = new cn_pastille([0, 0], 'text.svg');
            edit_box.add_pastille(this._details_pastille);
            this._details_pastille.svg_class = 'pastille_background white';
            this._details_pastille.title = 'Détails';
            const storey_ID = this._storey.ID;
            this._details_pastille.clicked = () => {
                const input = new cn_space_input();
                input.ID = spaces.some(
                    (sp) => sp.ID !== spaces[0].ID
                )
                    ? undefined
                    : spaces[0].ID;
                input.storey_ID = storey_ID;
                input.readonly = this._readOnly;
                input.space_type = spaces[0].space_type;
                //*** Name and usage */
                input.name = new cn_input_generic_field_string(
                    spaces.map((sp) => sp.get_base_name())
                );

                input.callback = () => {
                    obj._transaction_manager.push_transaction(
                        'Détails de pièces'
                    );
                    spaces.forEach((sp) => {
                        obj._transaction_manager.push_item_set(sp, ['name']);
                        if (input.name.value !== undefined)
                            sp.name = input.name.value;
                    });
                    
                    map.refresh();
                };
                map.call('space_input', input);
            };
        }

    }

    //***********************************************************************************
    //**** Draws
    //***********************************************************************************
    draw(camera) {
        return super.draw(camera);
    }
}
